import { useLayoutPreference } from '@/components/InvoiceReportDetailDrawer/hooks/useLayoutPreference';

export const JournalLayouts = {
  table: 'table',
  card: 'card',
} as const;

export type JournalLayout =
  (typeof JournalLayouts)[keyof typeof JournalLayouts];

const DEFAULT_LAYOUT: JournalLayout = JournalLayouts.table;

const STORAGE_KEY = 'paymentDetailDrawerJournalLayout:v1';

/**
 * Tracks the 仕訳 layout choice, persisted per user in localStorage
 * (NA-5531): the last-used layout is restored the next time the user
 * reopens the drawer or reloads the page. Users who never changed the
 * layout keep seeing the default (`table`). Mirrors `useTransactionsLayout`.
 */
export const useJournalLayout = () => {
  const { layout, setLayout } = useLayoutPreference<JournalLayout>({
    storageKey: STORAGE_KEY,
    defaultLayout: DEFAULT_LAYOUT,
    validValues: Object.values(JournalLayouts),
  });

  return {
    layout,
    setLayout,
  };
};
